import { render } from "./Wheel9.vue?vue&type=template&id=1844c86a"
const script = {}
script.render = render

export default script